import EasySpeech from 'easy-speech';
import { SETTINGS } from "../services/globalVars";
// import { CAST_text_to_speech } from "../cast/cast-control";
import { Sleep, genRanID } from '../utils/utils';
import { SPORT_BASE } from "../services/globalVars";
import { trigger_quick_sync } from "../sport/sport-function";
// import DBHandler from "../index-db/db-handler";

var speechBuffer = [];

const WebSpeech = () => {
   const synth = window.speechSynthesis;
   // const default_voice = 'Google UK English Male'; 
   const default_voice = 'English Australia';
   var voiceList = [];
   var rate = 1;
   var pitch = 1;
   var selected_voice = default_voice;
   var volume = 100;






   
   const text_to_speech = (text = 'Example, Testing, Testing. 1. 2. 3', forceSync = true) => {
      return new Promise(async (resolve) => {
         try {
            // CRITICAL: Add text and save BEFORE releasing queue
            // This ensures only ONE speech can modify cast_data at a time
            if (typeof SPORT_BASE?.sport_object?.scoring?.state?.match?.cast_data?.speech_text !== 'undefined') {
               // console.warn('>>> Appended Text to Cast Data: ', text);
               SPORT_BASE.sport_object.scoring.state.match.cast_data.speech_text.add_text({ text: text });
               if (forceSync) {
                  await trigger_quick_sync('text_to_speech - append text');
               }
            }

            text_to_speech_speak(text, forceSync);

            resolve(true);
         } catch (error) {
            console.error('ERROR - text_to_speech: ', error);
            resolve(false);
         }
      });
   }

   const text_to_speech_speak = (text = 'Example, Testing, Testing. 1. 2. 3', forceSync = true) => {
      return new Promise(async (resolve) => {
         try {
            // console.log('text_to_speech - text: ', text);
   
            // >>> Waiting for turn in Que
            let loopCount_que = 0;
            const queID = genRanID();
            speechBuffer.push(queID);
            while (speechBuffer[0] !== queID && loopCount_que < 1000) {
               await Sleep(100);
               loopCount_que++
            }
   
            // >>> Waiting for Speaking to Finish
            let loopCount_status = 0;
            while (EasySpeech.status().status === "init speak" && loopCount_status < 1000) {
               await Sleep(100);
               loopCount_status++;
            }
   
            populateVoiceList();
   
            // >>> CASTING OLD WAY <<<
            // if (GLOBAL_VARS.cast_running) { 
            //    CAST_text_to_speech(text); 
            // }
   
            
            // // CRITICAL: Add text and save BEFORE releasing queue
            // // This ensures only ONE speech can modify cast_data at a time
            // if (typeof SPORT_BASE?.sport_object?.scoring?.state?.match?.cast_data?.speech_text !== 'undefined') {
            //    // console.warn('>>> Appended Text to Cast Data: ', text);
            //    SPORT_BASE.sport_object.scoring.state.match.cast_data.speech_text.add_text({ text: text });
            //    if (forceSync) {
            //       await trigger_quick_sync('text_to_speech - append text');
            //    }
            // }
   
            
   
            // Release queue AFTER save completes, BEFORE speaking
            // This allows next speech to add its text while this one is speaking
            speechBuffer.shift();
   
            EasySpeech.init({ maxTimeout: 5000, interval: 250 })
               .then(async () => {
                  let voiceObject = null;
                  if (SETTINGS !== false) {
                     rate = SETTINGS.speech_rate;
                     selected_voice = SETTINGS.voice !== 'unset' ? SETTINGS.voice : default_voice;
                     if (SETTINGS.mute) {
                        volume = 0;
                     } else {
                        volume = 100;
                     }
                  }
   
                  for (const voice of voiceList) {
                     if (voice.name === selected_voice) {
                        voiceObject = voice;
                     }
                  }
   
                  // console.log('Call Speech: ', text);
                  await EasySpeech.speak({
                     text: text,
                     voice: voiceObject,
                     pitch: parseInt(pitch),
                     rate: parseFloat(rate),
                     volume: parseInt(volume),
                     // there are more events, see the API for supported events
                     boundary: e => console.debug('boundary reached')
                  });
                  // Queue already released above - no need to shift again
               }).catch(e => {
                  console.error(e);
                  // Queue already released above - no need to shift again
               });
               resolve(true);

         } catch (error) {
            console.error('ERROR - text_to_speech: ', error);
            resolve(false);
         }
      });
   }

   const populateVoiceList = (lang = 'en') => {
      voiceList = [];
      const voices = synth.getVoices();
      for (let a = 0; a < voices.length; a++) {
         if (voices[a].lang.includes(lang)) {
            voiceList.push(voices[a]);
         }
      }
      return voiceList;
   }

   const populateVoiceList_promise = (lang = 'en') => {
      return new Promise((resolve) => {
         populateVoiceList();
         populateVoiceList();
         resolve(true);
      });
   }

   return { populateVoiceList, populateVoiceList_promise, text_to_speech }
}

export default WebSpeech;